import { render } from "./CInput.vue?vue&type=template&id=0fb282e0"
import script from "./CInput.vue?vue&type=script&lang=js"
export * from "./CInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__